export const RESET = 'MEDIAOBJECT_UPDATE_RESET';
export const SET_ERROR = 'MEDIAOBJECT_UPDATE_SET_ERROR';
export const SET_RETRIEVED = 'MEDIAOBJECT_UPDATE_SET_RETRIEVED';
export const SET_UPDATED = 'MEDIAOBJECT_UPDATE_SET_UPDATED';
export const SET_VIOLATIONS = 'MEDIAOBJECT_UPDATE_SET_VIOLATIONS';
export const TOGGLE_LOADING = 'MEDIAOBJECT_UPDATE_TOGGLE_LOADING';
export const UPDATE_RETRIEVED = 'MEDIAOBJECT_UPDATE_UPDATE_RETRIEVED';



// WEBPACK FOOTER //
// ./src/store/modules/mediaobject/update/mutation_types.js